import Vue from "vue";

import FindRetailer from "../FindRetailer/FindRetailer.vue";

export function load() {
    const selector = "find-retailer";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(FindRetailer, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
